<template>
    <div>
        <el-dialog
                append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
            title="完成"
            top="60px"
            :visible.sync="dialogShow"
            width="50%"
            :modal-append-to-body="false">
            <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        完成
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                        <el-divider></el-divider>
                </template>
            <div :style="'max-height:'+ dialogBodyHight + 'px;overflow:scroll;'">
            <avue-form
                :option="option"
                v-model="form"
                v-if="dialogShow"
                @submit="formSubmit"
                 ref="form"
                @error="formError">
                <template slot="consumables">
                    <avue-crud
                        :option="consumablesOption"
                        :table-loading="loading"
                        :data="consumablesTableData"
                        :before-open="consumablesBeforeOpen"
                        v-model="consumablesForm"
                        ref="crud"
                        @row-update="consumablesTableRowUpdate"
                        @row-save="consumablesTableSave"
                        @row-del="consumablesTableDel"

                        >
                        <template slot="consumeNumForm">
                            <div>
                                <el-input v-model="consumablesForm.consumeNum" maxlength="10"  @input="consumeNumInput"></el-input>
                            </div>
                        </template>
                        <template slot="priceForm">
                            <div>
                                <el-input v-model="consumablesForm.price" maxlength="10"  @input="priceInput">
                                     <el-button slot="append" >元</el-button>
                                </el-input>
                            </div>
                        </template>
                    </avue-crud>
                </template>
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="remarkModel"></remarkModel>
                        </div>
                    </template>
                <template slot="attachList">
                    <div>
                        <vupload :fileList.sync="form.attachList"></vupload>
                    </div>
                </template>
                <template slot="project">
                    <div>
                        <el-row>
                            <el-col span="24" v-for="(item,index) in checkedServiceProjectData" :key="item">
                                <el-tag  style="margin-right:10px;margin-bottom:5px;">
                                    {{item.parentName}} | {{item.serviceContent}} <span>{{ item.score }}分</span> <span style="margin:0 15px;color:#F99B34;">￥{{item.price?Number(item.price).toFixed(2): '0.00'}}</span><span>&times;{{item.number}}</span>
                                </el-tag>
                                <el-tag @click="openSelectServiceProject" v-if="checkedServiceProjectData.length == (index + 1)"><i class="el-icon-edit"></i></el-tag>
                            </el-col>
                            <el-col span="24"  v-if="checkedServiceProjectData.length==0">
                                <el-tag @click="openSelectServiceProject"><i class="el-icon-edit"></i></el-tag>

                            </el-col>
                        </el-row>
                        <selectServiceProject
                            :checkedData="checkedServiceProjectData"
                            :treeData.sync="serviceProjectData"
                            @getCheckedData="getCheckedData"
                            ref="selectServiceProject" />
                    </div>
                </template>
                <template slot="workTime">
                    <a-time :time="form.workTime" @update="serviceTime"></a-time>
                        <!-- <el-input @input="workTimeInput" maxlength="10" :value="form.workTime">
                             <template slot="append">小时</template>
                        </el-input> -->
                </template>
                <template slot='contractId'>
                       <div style="display:flex">
                                        <el-input disabled v-model="form.contractName" placeholder="请选择 合同"></el-input>
                                        <el-button type="primary" size="small" @click="choiceConstract">选择</el-button>
                                </div>
                </template>
                <template slot="menuForm">
                    <!-- <el-button @click="closeDialog" ><span class="el-icon-close"></span> 取消</el-button> -->
                </template>
            </avue-form>
            </div>
            <template slot="footer">
                <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
            </template>
        </el-dialog>
        <hr-dialog
          title="选择合同"

          :visible.sync="choiceContractDialogFlag"
         :allowFull='false'
          width="80%"
        >
         <template slot="body">
            <choiceContract

            :projectId="projectId"
            @getConstract="getConstract"
          ></choiceContract>
         </template>
        </hr-dialog>


    </div>
</template>
<script>
import {
    endOption,
    consumablesOption,
    omitNumber,
    omitNumber2
} from "./option.js";
import {
        getRemarkList,
        finish,
        getDeviceId,
        getConsumableList
 } from "@/api/crmedical/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
import selectServiceProject from "./select-service-project"
import aTime from "../components/aTime.vue";
import {fieldDetail} from "@/api/v4ward/ordersetting/setting/selfForm"
import choiceContract from "@/components/choiceContract/choiceContract"
export default {
    components:{
        remarkModel,vupload,selectServiceProject,aTime,choiceContract
    },
    data(){
        return{
            choiceContractDialogFlag:false,
            taskId:'',
            dialogFull:false,
            serviceProjectData:[],//服务项目数据
            consumablesTableData:[],
            checkedServiceProjectData:[],//已选择的服务项目
            form:{
                orderId:'',
                attachList:[],
                areaId:'',
                contractName:''
            },
            treeFormAreaData:[],//懒加载区域树 --报修表单中
            treeProps: {//报修表单 --需求区域树的配置
                //标题
                label: 'name',
                //值
                value: 'id',
                //子节点
                children: 'zones',
                //是否叶子节点
                isLeaf: 'hasChildren',
                //本节点类型key值
                objectType: 'id',
                //本节点类型名
                objectTypeName: 'name',
            },
            data:{},
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            option:endOption,
            consumablesOption:consumablesOption,
            consumablesForm:{
                consumableId:0,
                consumeNum:0,
                price:0,
                totalScore:'',//服务得分总分
            },
            consumablesList:[],
            orderId:'',
            projectId:'',
            actionType:7,//按钮
            submitFlag:true,//防重提交
            repairFlag:false,
            serviceHourFlag:false,
            descriptionFlag:false,
            uploadFileFlag:false,
            contractFlag:false,
            moduleType:"",
        }
    },
    created(){

    },
    watch:{
        "consumablesForm.consumableId"(value){
             this.consumablesForm.consumeNum = 0;
            for(let i = 0;i<this.consumablesList.length;i++){
                if(this.consumablesList[i].id == value){
                    this.consumablesForm.size =  this.consumablesList[i].specification;
                    this.consumablesForm.price = this.consumablesList[i].price;
                    break;
                }else{
                    this.consumablesForm.price = 0;
                }
            }
        },
    },
    mounted(){
            this.dialogFull = false;
            let bodyHight = document.body.clientHeight;

            this.dialogBodyHight = bodyHight - 300;

    },
    methods:{
        getConstract(val){
            console.log(val)
            this.form.contractName = val.name
            this.form.contractId = val.id
            this.choiceContractDialogFlag = false
        },
        choiceConstract(){
            this.choiceContractDialogFlag = true
        },
         //获取字段填写修饰
        async getFieldDetail(projectId,moduleType,actionType){

            console.log("执行了")
            let obj = {
                projectId:projectId,
                moduleType:moduleType,
                actionType:actionType
            }
            let fieldObj
            fieldObj  = this.findObject(this.option.column,'contractId')
            await fieldDetail(obj).then(res=>{
                let repair
                let serviceHour,description,uploadFile,contract
                res.data.forEach(item=>{
                    if(item.fieldCode == "repair"){
                        repair =item
                    }
                    if(item.fieldCode == "serviceHour"){
                        serviceHour =item
                    }
                    if(item.fieldCode == "description"){
                        description =item
                    }
                     if(item.fieldCode == "uploadFile"){
                        uploadFile =item
                    }
                    if(item.fieldCode=='contract'){
                        contract= item
                    }
                })
                if(contract){
                    if( contract.defaultMustFlag ==0){

                        this.contractFlag=false
                    }else{
                        this.contractFlag=true
                    }
                }
                if(repair){
                    if( repair.defaultMustFlag ==0){

                        this.repairFlag=false
                    }else{
                        this.repairFlag=true
                    }
                }
                if(serviceHour){
                    if( serviceHour.defaultMustFlag ==0){

                        this.serviceHourFlag= false
                    }else{
                        this.serviceHourFlag= true
                    }
                }
                if(description){
                    if( description.defaultMustFlag ==0){

                        this.descriptionFlag= false
                    }else{
                        this.descriptionFlag= true
                    }
                }
                if(uploadFile){
                    if( uploadFile.defaultMustFlag ==0){

                        this.uploadFileFlag =false
                    }else{
                        this.uploadFileFlag =true
                    }
                }


            })
        },
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
        formSubmit1(){
            // console.log(this.$refs.form.submit)
            this.$refs.form.submit();
        },
          serviceTime(date){
            //服务完成时间
            this.form.workTime =Number(date.hour)*60 + Number(date.minutes);
        },
        // 打开完成表单
        openDialog(data){
             let orderRow = data.orderRow
             this.moduleType = orderRow.moduleType
             console.log("333")
                 this.getFieldDetail(orderRow.projectId,orderRow.moduleType,8)
            console.log('openDialog(data)======>',data);
            this.taskId = data.taskId
            this.subModuleId = data.subModuleId?data.subModuleId:'';
            this.dialogShow = true;
            this.orderId = data.orderId;
            this.projectId = data.projectId;
            this.actionType = data.actionType || 7;
            this.form = {
                orderId:data.orderId,
                attachList:[],
            }
            this.serviceProjectData = [];
            this.consumablesTableData = [];
            this.checkedServiceProjectData = [];
            // 获取备注模板
            getRemarkList({orderId:data.orderId,actionType:data.actionType}).then(res=>{
                this.$refs.remarkModel.setRemarkList(res.data);

            })
            // 获取设备列表
            getDeviceId({projectId:this.projectId, subModuleId:this.subModuleId }).then(res=>{
                const column = this.findObject(this.option.column,'deviceId');
                column.dicData = res.data;
            })
            // 获取耗材列表
            getConsumableList({projectId:this.projectId, subModuleId:this.subModuleId }).then(res=>{
                const column = this.findObject(this.consumablesOption.column,'consumableId');

                column.dicData = res.data;
                this.consumablesList = res.data;
            })
        },
        // 获取选择的服务项目
        getCheckedData({checked,treeData}){
            this.checkedServiceProjectData = checked; //将选择的服务项目展示出来
            console.log(this.checkedServiceProjectData)
            let totalScore = 0;
            this.checkedServiceProjectData.forEach(ele=>{//计算服务总分
                totalScore += ele.score * Number(ele.number);
            })
            this.form.totalScore = totalScore;
            console.log(checked)
            console.log(treeData)
        },
        // 材料弹窗打开前
        consumablesBeforeOpen(done,type){
            if(type=='add'){
                this.consumablesForm.price=0;
                this.consumablesForm.consumeNum=0;
                this.consumablesForm.consumableId='';
            }
            done();
        },
        // 编辑材料
        consumablesTableRowUpdate(row,index,done,d){
            row.money = (Number(this.consumablesForm.consumeNum)*Number(this.consumablesForm.price)).toFixed(2);
            this.consumablesTableData.splice(index,1,row);
            done();

        },
        // 删除材料
        consumablesTableDel(row,index){
            this.consumablesTableData.splice(index,1);
        },
        // 添加材料
        consumablesTableSave(form,done){
            form.money = (Number(this.consumablesForm.consumeNum)*Number(this.consumablesForm.price)).toFixed(2);
            this.consumablesTableData.push(form);
            done();
        },
        // 数量输入框 控制
        consumeNumInput(e){
            console.log(e)
            this.consumablesForm.consumeNum = omitNumber(e);

        },
        // 单价输入框 控制
        priceInput(e){
            console.log(e)
            console.log(omitNumber2(e))
            this.consumablesForm.price = omitNumber2(e);
        },
        // 打开选择服务项目
        openSelectServiceProject(){
            this.$refs.selectServiceProject.openSelectTree({projectId:this.projectId,subModuleId:this.subModuleId,moduleType:this.moduleType});
        },
        // 服务工时
        workTimeInput(e){
            this.form.workTime = omitNumber(e);
        },

        closeDialog(){
            this.dialogShow = false;
        },

        formError(done){
            done()
        },
        formSubmit(form,done){
            console.log("checkedServiceProjectData",this.checkedServiceProjectData.length)
            console.log("serviceHourFlag",this.form.workTime)
            if(this.repairFlag){
                if(this.checkedServiceProjectData.length==0){
                    this.$message.error("请选择服务项目")
                    done()
                    return
                }
            }
            if(this.serviceHourFlag){
                if(this.form.workTime==0){
                    this.$message.error("请填写服务工时")
                    done()
                    return
                }
            }
            if(this.contractFlag){
                if(this.form.contractId==''){
                    this.$message.error("请选着合同")
                    done()
                    return
                }
            }
            if(this.descriptionFlag){
                if(this.form.remark==''){
                    this.$message.error("请输入备注")
                    done()
                    return
                }
            }
            if(this.uploadFileFlag){
                if(this.form.attachList.length==0){
                    this.$message.error("请上传附件")
                    done()
                    return
                }
            }



            this.form.amount = 0;
            this.form.consumables = [];
            this.consumablesTableData.forEach(ele=>{ //计算耗材总价 & 将耗材整理成集合
                this.form.amount += Number(ele.money);
                let temObj = {};
                temObj.consumableId = ele.consumableId;
                temObj.consumeNum = ele.consumeNum;
                temObj.consumePrice = ele.price;
                this.form.consumables.push(temObj);
            })
            let imgIds = '';
            this.form.attachList.forEach(ele=>{ //拼接图片ud
                imgIds += ele.id + ',';
            })
            let moduleJson = { //业务数据
                deviceId:this.form.deviceId,//设备id
                orderId:this.form.orderId,//工单id
                amount:this.form.amount,//耗材总价
                serviceHour:this.form.workTime,//服务工时
                description:this.form.remark,//备注 --描述
                remark:this.form.remark,//备注
                imgIds:imgIds,//图片 视频
                voiceIds:this.form.voiceIds,//音频
                consumables:this.form.consumables, //材料清单
                taskId:this.taskId,
                contractId:this.form.contractId
            }

            moduleJson = JSON.stringify(moduleJson);


            // 服务项目
            let serviceProject = [];
            this.checkedServiceProjectData.forEach(ele=>{
                serviceProject.push(ele);
            })
            let params = {
               moduleJson:moduleJson,//业务数据
               workTime:this.form.workTime,//服务工时
               attachList:this.form.attachList,//附件
               remark:this.form.remark,//备注
               orderId:this.form.orderId,//工单id
               itemListIds:serviceProject,//服务项目
            }
            console.log(params);
            // this.dialogShow = false;
            // this.$emit('handleClose',function(){console.log('关闭历程表')})
            // return;
            finish(params).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})

                this.dialogShow = false;
                done()
            }).catch(err=>{


                done()
            })
        },


    }
}
</script>
